module.exports = __webpack_public_path__ + "img/Fr-T200.98153d4f.gif";